import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import RoleControlled from '../../_common/RoleControlled'

import { URL } from '../../../const'
import { toggleVisibility, showToast } from '../../../actions'

import InfoItem from './InfoItem'
import Loader from '../../_common/Loader'
import AddInfo from './AddInfo'

export class NearbyInformations extends PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      loading: true,
      data: [],
      addingNewInfo: false,
      show_panel: false
    }
  }

  componentDidMount () {
    this._fetchData()
  }
  async _fetchData () {
    this.setState({ loading: true })
    const config = {
      headers: {
        'Authorization': `Token ${this.props.user.token}`
      }
    }
    const url = `${URL}nearby_informations/${this.props.propertyID}`
    try {
      const res = await axios.get(
        url,
        config
      )
      const data = res.data.items
      this.setState({ data, loading: false, show_panel: res.data.show })
    } catch (error) {
      console.log('An error occured while fetching residents data.')
    }
  }
  _handleEnablePanel (e) {
    this.setState({ show_panel: e.target.checked })
    this.props.toggleVisibility(this.props.propertyID, 2, e.target.checked)
  }
  _handleAddClick () {
    this.setState({ addingNewInfo: true })
  }
  _handleCancelClick () {
    this.setState({ addingNewInfo: false })
  }

  async _handleSaveInfo (data, image) {
    const url = `${URL}nearby_informations/${this.props.propertyID}`
    const config = {
      headers: {
        'Authorization': `Token ${this.props.user.token}`,
        'Content-Type': 'multipart/form-data'
      }
    }
    const formData = new FormData()
    formData.append('data', JSON.stringify(data))
    if (image) {
      formData.append('image', image, `nearby_info-${data.id || '000'}-${Date.now()}`)
    }

    try {
      await axios.post(
        url,
        formData,
        config
      )
      this.props.showToast('保存しました！', 'primary')
      this._fetchData()
    } catch (error) {
      console.log('error: ', error)
      this.props.showToast('エラーが発生しました。', 'danger')
    }
  }
  async _handleCreateInfo (data, image) {
    const url = `${URL}nearby_informations/${this.props.propertyID}`
    const config = {
      headers: {
        'Authorization': `Token ${this.props.user.token}`,
        'Content-Type': 'multipart/form-data'
      }
    }

    const formData = new FormData()
    formData.append('data', JSON.stringify(data))
    if (image) {
      formData.append('image', image, `nearby_info-${data.id || '000'}-${Date.now()}`)
    }

    try {
      await axios.post(
        url,
        formData,
        config
      )
      this.setState({ addingNewInfo: false })
      this.props.showToast('保存しました！', 'primary')
      this._fetchData()
    } catch (error) {
      console.log('error: ', error)
      this.props.showToast('エラーが発生しました。', 'danger')
    }
  }
  async _handleDeleteInfo (id) {
    const url = `${URL}nearby_informations?id=${id}`
    const config = {
      headers: {
        'Authorization': `Token ${this.props.user.token}`
      }
    }
    try {
      await axios.delete(
        url,
        config
      )
      this.props.showToast('削除しました。', 'danger')
      this._fetchData()
    } catch (error) {
      console.log('error: ', error)
    }
  }

  _renderMain () {
    return (
      <div className="inner_container">
        { this._renderAddItem() }
        { this._renderList() }
      </div>
    )
  }

  _renderAddItem () {
    if (this.state.addingNewInfo) {
      return <AddInfo saveData={this._handleCreateInfo.bind(this)} cancel={this._handleCancelClick.bind(this)}/>
    }
    return null
  }

  _renderList () {
    return this.state.data.map(item => {
      return (
        <InfoItem
          info={item}
          key={item.id}
          role={this.props.user.user_role}
          saveData={this._handleSaveInfo.bind(this)}
          deleteData={this._handleDeleteInfo.bind(this)}
        />)
    })
  }
  _renderLoader () {
    if (this.state.loading) {
      return <Loader classname="loader_dot_circle small"/>
    }
    return null
  }
  render () {
    if (this.props.activeDetails.data.owner_id === 1) { return null }
    return (
      <div>
        <h4 className="page_title bold flex justify-between">
          <div className="title flex">
            <span>周辺情報一覧</span>
            { this._renderLoader() }
          </div>
          <RoleControlled role={this.props.user.user_role} acceptedRoles={[0, 1]}>
            <div className="switch">
              <input type="checkbox" id="showSwitch" className="switch-input" key="checkbox" onChange={this._handleEnablePanel.bind(this)} checked={this.state.show_panel}/>
              <label htmlFor="showSwitch" className="switch-label" key="label">
                <span className="toggle--on">表示</span>
                <span className="toggle--off">非表示</span>
              </label>
            </div>
          </RoleControlled>
        </h4>
        {
          this.state.show_panel
            ? (
              <div>
                <RoleControlled role={this.props.user.user_role} acceptedRoles={[0, 1]}>
                  <div className="add_btn_container flex">
                    <button className="btn primary small_btn flex align-center" onClick={this._handleAddClick.bind(this)}>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-add">
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                      </svg>
                      <span>追加</span>
                    </button>
                  </div>
                </RoleControlled>

                <div className="list_container">
                  {
                    this.state.loading
                      ? <Loader classname="loader_dot_circle"/>
                      : this._renderMain()
                  }
                </div>
              </div>
            )
            : null
        }
      </div>
    )
  }
}

function mapStateToProps ({ user, activeDetails }) {
  return { user, activeDetails }
}

export default connect(mapStateToProps, { showToast, toggleVisibility })(NearbyInformations)



// WEBPACK FOOTER //
// ./src/components/Properties/NearbyInformations/index.js